export const TimeFrames = {
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  CURRENT_WEEK: 'currentWeek',
  CURRENT_MONTH: 'currentMonth',
  OLDER: 'older',
};

/**
 * @enum {string}
 * @deprecated This enum is deprecated, please use ItemDateScheduledTypes from enums/temporal
 */
export const DateScheduledTypes = {
  TODAY: 'today',
  FUTURE_DATE: 'future_date',
};

export const DateStringLength = {
  BIRTH_DATE: 10,
};

/**
 * Units of time, compatible with those accepted by moment.
 * @type {Object.<string, TimeUnitName>}
 */
export const TimeUnit = {
  MILLISECONDS: 'milliseconds',
  SECONDS: 'seconds',
  MINUTES: 'minutes',
  HOURS: 'hours',
};

/**
 * Time zone identifiers.
 * @type {Object.<string, string>}
 */
export const TimeZoneId = {
  UTC: 'UTC',
  PT: 'America/Los_Angeles',
};
